import { Box, Button } from '@mui/material'
import React from 'react'
import { List2 } from '../../../../../core/global/Icons'
import LimitText from "react-show-more-text"
import { domain } from '../../../../../core/Env';
import { DirectTabLoader } from '../../../../../core/loader/DirectTabLoader';

export const Lists = ({ current, l, k, menuHandler, postHandler, disableHandler, updateHandler, typeView, viewAction}) => {

	const urlHandler = async () => {
		let ssoUrls = `${domain('shp').url}${l.status === 1 ? `/psl/preview/real_state/property/${window.btoa(`prm_${l.id}`)}` : `/psl/sales-page/real_state/property/${window.btoa(`prm_${l.id}`)}`}`
		await DirectTabLoader('ShpWN', ssoUrls)
	}

	return (

		<Box key={k} display="flex" alignItems="center" border={"1px solid #E5F2EC"} p={1} width="100%" mb={1}>
			<Box width="10%" fontSize={12} fontWeight={400} color="#313131">{k + 1}</Box>
			<Box width="15%" color="#313131" fontSize={12} fontWeight={600}>{l.name}</Box>

			<Box width="40%" fontSize={12} fontWeight={600} sx={{ cursor: 'pointer', ':hover': { color: "#008000" } }} color="#313131" onClick={() => urlHandler()} >
				<LimitText lines={1} more="" less="" expanded={false} truncatedEndingComponent={"... "} >
					{domain('shp').url}{l.status === 1 ? `/psl/preview/real_state/property/${window.btoa(`prm_${l.id}`)}` : `/psl/sales-page/real_state/property/${window.btoa(`prm_${l.id}`)}`}
				</LimitText>
			</Box>
			<Box width="15%" color="#313131" fontSize={14} >{l.created_at}</Box>
			<Box width="10%" display="flex" justifyContent="center">
				<Box textAlign="center" width={100} py={0.5} borderRadius={10} fontSize={12} fontWeight={12} color={l.status === 1 ? '#009F4D' : l.status === 2 ? '#0876F8' : '#333'} bgcolor={l.status === 1 ? '#CEFFDC' : l.status === 2 ? '#AFD4FF' : '#D9D9D9'}>
					{l.status === 1 ? 'Saved' : l.status === 2 ? 'Posted' : 'Disabled'}
				</Box>
			</Box>

			<Box width="10%" display="flex" justifyContent="center" fontSize={15} fontWeight={400} color="#313131">
				<Box display="flex" justifyContent="center">
					<Box sx={{ position: 'relative', cursor: 'pointer' }} width="100%">

						<Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }} p={1.5} onMouseEnter={() => menuHandler(l.id, true)} onMouseLeave={() => menuHandler(l.id, false)}>
							{
								(current.stat && (current.value === l.id)) && (
									<Box bgcolor="#fff" borderRadius={2} mt={0.5} className="shadow-sm" width={180} py={1.5}>
										{l.status === 1 && <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => postHandler(l)}>Post</Box>}
										{l.status !== 3 && <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => updateHandler(l)}>Update</Box>}
										{l.status === 2 && <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => disableHandler(l)}>Disabled</Box>}
										{l.status === 3 && <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12} onClick={() => postHandler(l)}>Enable</Box>}
										{(l.status === 1 || l.status === 2) && <Box component={Button} justifyContent="start" fullWidth bgcolor="#fff" color="#000" fontSize={12}
											onClick={() => typeView('desktop', l)}
										>View</Box>}
									</Box>)
							}
						</Box>
						<Box display="flex" flexDirection="row-reverse" width="100%">
							<Box component={Button} minWidth="" onMouseEnter={() => menuHandler(l.id, true)} onMouseLeave={() => menuHandler(l.id, viewAction.data.viewAs.modal, false)}><List2 fill="#333" width={20} /></Box>
						</Box>
					</Box>
				</Box>
			</Box>
			
		</Box>


	)
}
